import request from '../config/axiosConfig';
import { GET_LIST_POSTS, GET_POST_INFO, CREATE_POST, UPDATE_POST, DELETE_POST } from '../constants/postApiEndPoint';

export const getPosts = async (params) => {
  return (
    await request({
      url: GET_LIST_POSTS,
      method: 'GET',
      params,
    })
  )?.data;
};

export const getPostInfo = async (id) => {
  return (
    await request({
      url: GET_POST_INFO,
      method: 'GET',
      params: { id },
    })
  )?.data;
};

export const createPost = async (data) => {
  return (
    await request({
      url: CREATE_POST,
      method: 'POST',
      data,
    })
  )?.data;
};

export const updatePost = async (id, data) => {
  return (
    await request({
      url: UPDATE_POST,
      method: 'POST',
      params: { id },
      data,
    })
  )?.data;
};

export const deletePost = async (id) => {
  return (
    await request({
      url: DELETE_POST,
      method: 'DELETE',
      params: { id },
    })
  )?.data;
};
